import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
	selector: 'fms-breadcrumbs',
	templateUrl: 'page-breadcrumbs.component.html',
	styles: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [RouterLink, RouterLinkActive],
})
export class PageBreadcrumbsComponent {
	@Input() showHome = true;
	@Input() homePath: string[] | null = null;
}
